<template>
  <div class="app-container">
    <span class="title">经营回收品类</span>
    <div class="switch-tab">
      <el-radio-group v-model="activeTab" @input="getPie">
        <el-radio-button label="1">普通订单</el-radio-button>
        <el-radio-button label="2">批量订单</el-radio-button>
      </el-radio-group>
    </div>
    <div class="pieclass">
      <div id="pieChart" style="width: 300px; height: 300px"></div>
      <div class="pre-list-class">
        <div
          class="pie-list"
          v-for="(item, index) in pieChartOption.series[0].data"
          :key="index"
        >
          <div class="pie-color" :style="'background:' + pieChartOption.color[index]"></div>
          <div class="pie-content">
            <div class="pie-contains">{{ item.percentage }}</div>
            <div class="pie-type">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <span class="title">地区成交量数据</span>
    <div class="barclass">
      <div class="barData">
        <div class="bar-title">
          <span class="num">{{ total }}</span>
          <span class="unit">单</span>
        </div>
        <div class="bar-content">
          总成交量
        </div>
      </div>
      <div
        id="barChart"
        ref="barChart"
        style="width: 1000px; height: 500px"
      ></div>
      <div class="bar-list-calss" v-if="sfen">
        <div class="bar-region">
          <div class="title">{{ sfen }}</div>
          <div class="content">所选择地区</div>
        </div>
        <div class="bar-item1">
          <div class="bar-color"></div>
          <div class="bar-content">
            <div class="bar-contains">{{ order }}</div>
            <div class="bar-type">
              成交量
            </div>
          </div>
        </div>
        <!-- <div class="bar-item2">
          <div class="bar-color"></div>
          <div class="bar-content">
            <div class="bar-contains">3300单</div>
            <div class="bar-type">
              2022年成交量
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      sfen: "",
      order: "",
      activeTab: "1",
      // 饼图参数
      pieChartOption: {

        tooltip: {
          trigger: "item",
          backgroundColor: "#e8f8f7",
          padding: [35, 21, 35, 21],
          textStyle: {
            color: "rgba(0, 0, 0)"
          }
        },
        color: [
          "#cdf0ee",
          "#9dd7e4",
          "#009269",
          "#00bb84",
          "#005a39",
          "#005a39"
        ],
        series: [
          {
            // name: "饼图",
            type: "pie",
            radius: ["40%", "60%"],
            data: [],
            label: {
              //  去除指示线
              normal: {
                show: false
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      // 柱状图参数
      barChartOption: {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#e8f8f7",
          padding: [35, 21, 35, 21],
          textStyle: {
            color: "rgba(100, 100, 100)"
          }

          // formatter: function(params) {
          //   return '<div style="width:80px">' + params[0].name + '<br>' + '<span>订单</span>' + ':' + '<span style="color: #00B83F;">' + params[0].value + '</span>' + '</div>';
          // }
        },
        // legend: {
        //   left: "right",
        //   data: ["城市"]
        // },
        legend: {
          data: ["未完成", "已完成", "已取消"],
          left: "10%"
        },
        color: ["#6597f8"],
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 30
          },
          {
            type: "slider"
          }
        ],
        xAxis: {
          type: "category",
          data: [
            "湖南",
            "湖北",
            "江西",
            "山西",
            "武汉",
            "上海",
            "江苏",
            "山东",
            "广东",
            "西安",
            "安徽"
          ],
          axisLabel: {
            color: "rgba(100, 100, 100)"
          }
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "未完成",
            type: "bar",
            barGap: 0,
            color: ["#F3B617"]
          },
          {
            name: "已完成",
            type: "bar",
            barGap: 0,
            color: ["#00b982"]
          },
          {
            name: "已取消",
            type: "bar",
            barGap: 0,
            color: ["#BDC4D0"]
          }
        ]
      },
      total: 0
    };
  },
  mounted() {
    this.getPie();
    let that = this;
    setTimeout(() => {
      that.getBar();
    }, 1000);
  },
  methods: {
    //切换经营回收品类
    handleTabChange() {},
    getPie() {
      this.HttpService.get(
        `/autoapp-default-server-recovery/api/tblRecycleOrder/getSkuNumByUserType?userType=${this.activeTab}`
      ).then(res => {
        res.data.forEach(element => {
          element.color = this.fliterColor(element.goodsType);
          element.value = element.orderNums;
          element.name = element.goodsType;
          delete element.goodsType;
          delete element.orderNums;
        });

        this.pieChartOption.series[0].data = res.data;
        console.log(this.pieChartOption.series[0].data, " res.data11");
        // 初始化饼图
        var pieChartDom = document.getElementById("pieChart");
        var pieChart = echarts.init(pieChartDom);
        this.pieChartOption && pieChart.setOption(this.pieChartOption);
      });
    },
    getBar2() {
      this.HttpService.get(
        `/autoapp-default-server-recovery/api/tblRecycleOrder/getOrderNumsBySfen`
      ).then(res => {
        let arr1 = [];
        let arr2 = [];
        if (res.data.OrderNums) {
          for (var i = 0; i < res.data.OrderNums.length; i++) {
            arr1[i] = res.data.OrderNums[i].sfen;
            arr2[i] = res.data.OrderNums[i].orderNums;
          }
        }

        console.log(arr1, "arr1");
        console.log(arr2, "arr2");
        this.barChartOption.xAxis.data = arr1;
        this.barChartOption.series[0].data = arr2;
        this.total = res.data.total;
        // 初始化柱状图
        var barChartDom = document.getElementById("barChart");
        var barChart = echarts.init(barChartDom);
        let that = this;
        this.barChartOption && barChart.setOption(this.barChartOption);
        barChart.on("click", function(params) {
          that.sfen = params.name;
          that.order = params.value;
        });
      });
    },
    getBar() {
      this.HttpService.get(
        `/autoapp-default-server-recovery/api/tblRecycleOrder/getNumsByProvince`
      )
        .then(res => {
          const provinceData = res.data.provinceNumsVOS || [];
          const arr1 = provinceData.map(item => item.province);
          const arr2 = provinceData.map(item => item.unFinish || 0);
          const arr3 = provinceData.map(item => item.finish || 0);
          const arr4 = provinceData.map(item => item.cancel || 0);

          this.barChartOption.xAxis.data = arr1;
          this.barChartOption.series[0].data = arr2;
          this.barChartOption.series[1].data = arr3;
          this.barChartOption.series[2].data = arr4;

          this.total = res.data.total || 0;
          this.initBarChart();
        })
        .catch(error => {
          console.error("获取省份数据失败:", error);
          this.total = 0;
        });
    },

    initBarChart() {
      const barChartDom = document.getElementById("barChart");
      const barChart = echarts.init(barChartDom);

      this.barChartOption && barChart.setOption(this.barChartOption);
    },
    fliterColor(val) {
      if (val === "空调") {
        return "#005a39";
      } else if (val === "洗衣机") {
        return "#9dd7e4";
      } else if (val === "电脑") {
        return "#009269";
      } else if (val === "电视机") {
        return "#00bb84";
      } else if (val === "冰箱") {
        return "#cdf0ee";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .app-container {
  background: red !important;
}
.title {
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-weight: 400;
}
.switch-tab {
  margin: 20px 0;
}
.pieclass {
  margin: auto;
  // padding: 0 22%;
  display: flex;
  border-bottom: 2px dashed #eee;
  margin-bottom: 37px;

  .pre-list-class {
    display: flex;
    flex-wrap: wrap;
    height: 200px;
    margin: 5% 0;
    .pie-list {
      display: flex;
      align-items: center;
      margin: 20px;
      height: 60px;
      .pie-color {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      .pie-content {
        margin-left: 24px;
        .pie-contains {
          font-size: 36px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
        }
        .pie-type {
          color: rgba(153, 153, 153, 1);
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
  }
}
.barclass {
  display: flex;
  .title {
    color: rgba(0, 0, 0, 1);
    font-size: 20px;
    font-weight: 400;
  }
  .barData {
    margin-top: 70px;
    .bar-title {
      display: flex;
      align-items: end;

      .num {
        color: rgba(0, 184, 130, 1);
        font-weight: 400;
        font-size: 48px;
      }
      .unit {
        font-size: 20px;
      }
    }
    .bar-content {
      color: rgba(153, 153, 153, 1);
      font-size: 18px;
      font-weight: 400;
    }
  }
  .bar-list-calss {
    margin: 4%;
    .bar-region {
      margin-bottom: 61px;
      .title {
        font-size: 36px;
        color: rgba(0, 0, 0, 1);
        font-weight: 400;
      }
      .content {
        font-size: 18px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
    .bar-item1 {
      display: flex;
      align-items: center;
      margin-bottom: 45px;
      .bar-color {
        width: 20px;
        height: 20px;
        opacity: 1;
        background: #00b985;
        border-radius: 50%;
      }
      .bar-content {
        margin-left: 10px;
        .bar-contains {
          font-size: 36px;
          color: rgba(0, 0, 0, 1);
          font-weight: 400;
        }
        .bar-type {
          color: rgba(153, 153, 153, 1);
          font-weight: 400;
          font-size: 20px;
        }
      }
    }
    .bar-item2 {
      display: flex;
      align-items: center;
      .bar-color {
        width: 20px;
        height: 20px;
        opacity: 1;
        background: rgba(0, 186, 132, 1);
        border-radius: 50%;
      }
      .bar-content {
        margin-left: 10px;
        .bar-contains {
          font-size: 36px;
          color: rgba(0, 0, 0, 1);
          font-weight: 400;
        }
        .bar-type {
          color: rgba(153, 153, 153, 1);
          font-weight: 400;
          font-size: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/index.vue